import { useEffect, useReducer } from 'react';
import reducer from './reducer';
import useMemoCompare from 'hooks/useMemoCompare';
import { getDocData, getCollectionData } from 'utils/format';

const useFirestoreQuery = query => {
  const INITIAL_STATE = {
    status: query ? 'loading' : 'idle',
    data: undefined,
    error: undefined,
  };

  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  const queryCached = useMemoCompare(query, prevQuery => {
    // Use built-in Firestore isEqual method to determine if "equal"
    return prevQuery && query && query.isEqual(prevQuery);
  });

  useEffect(() => {
    if (!queryCached) {
      dispatch({ type: 'idle' });
      return;
    }
    dispatch({ type: 'loading' });

    return queryCached.onSnapshot(
      response => {
        const data = response.docs ? getCollectionData(response) : getDocData(response);
        dispatch({ type: 'success', payload: data });
      },
      error => {
        dispatch({ type: 'error', payload: error });
      }
    );
  }, [queryCached]);

  return state;
};
export default useFirestoreQuery;
